/* =========================================================
   DOPAMEAN — Collection tabs
   Switches the visible product panel when a tab is clicked.
   Self-contained: scopes to each .collection-tabs section so
   multiple instances on a page don't interfere.
   ========================================================= */
(function () {
  function activate(section, index) {
    const tabs = section.querySelectorAll('.collection-tabs__tab');
    const panels = section.querySelectorAll('.collection-tabs__panel');
    let activeTab = null;
    tabs.forEach((t) => {
      const match = t.dataset.tab === String(index);
      t.classList.toggle('active', match);
      t.setAttribute('aria-selected', match ? 'true' : 'false');
      t.setAttribute('tabindex', match ? '0' : '-1');
      if (match) activeTab = t;
    });
    panels.forEach((p) => {
      const match = p.dataset.panel === String(index);
      p.classList.toggle('active', match);
      if (match) {
        p.removeAttribute('hidden');
      } else {
        p.setAttribute('hidden', '');
      }
    });

    // Keep the shared "View all" link (next to the section heading, see
    // .dpm-collection-title-row in collection-tabs.liquid) pointed at the
    // active tab's collection -- it replaced a per-panel link that used
    // to live below each grid, so it has to follow tab switches instead.
    const viewAll = section.querySelector('[data-dpm-tabs-view-all]');
    if (viewAll && activeTab) {
      const url = activeTab.dataset.collectionUrl;
      const link = viewAll.querySelector('a');
      if (url) {
        link.href = url;
        link.setAttribute('aria-label', 'View all in ' + activeTab.dataset.collectionTitle);
        viewAll.hidden = false;
      } else {
        viewAll.hidden = true;
      }
    }
  }

  function bindSection(section) {
    if (section.dataset.dpmTabsBound === '1') return;
    section.dataset.dpmTabsBound = '1';

    const tabs = section.querySelectorAll('.collection-tabs__tab');
    if (tabs.length === 0) return;

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activate(section, tab.dataset.tab));

      // Arrow-key navigation between tabs for accessibility
      tab.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'Home' && e.key !== 'End') return;
        e.preventDefault();
        const list = Array.from(tabs);
        const currentIndex = list.indexOf(tab);
        let nextIndex = currentIndex;
        if (e.key === 'ArrowRight') nextIndex = (currentIndex + 1) % list.length;
        else if (e.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + list.length) % list.length;
        else if (e.key === 'Home') nextIndex = 0;
        else if (e.key === 'End') nextIndex = list.length - 1;
        const nextTab = list[nextIndex];
        nextTab.focus();
        activate(section, nextTab.dataset.tab);
      });
    });
  }

  function init() {
    document.querySelectorAll('.collection-tabs').forEach(bindSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-bind after Shopify section re-renders in the theme editor
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.querySelector) {
      e.target.querySelectorAll('.collection-tabs').forEach((s) => {
        delete s.dataset.dpmTabsBound;
        bindSection(s);
      });
    }
  });
})();
